export const getCurrencySymbol = (currency?: string, locale?: string): string => {
  return (0)
    .toLocaleString(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim()
}

export function getCurrencyPosition(locale: string, currency: string): "left" | "right" {
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
  })

  const parts = formatter.formatToParts(123)

  const currencyIndex = parts.findIndex((p) => p.type === "currency")
  const numberIndex = parts.findIndex((p) => p.type === "integer")

  return currencyIndex < numberIndex ? "left" : "right"
}

export const formatCurrency = (value: number, currency?: string | null, locale?: string): string => {
  return value.toLocaleString(locale, { style: "currency", currency: currency ?? undefined })
}

export const currencySymbol = (currency?: string | null, locale?: string): string => {
  const number = 0
  return number
    .toLocaleString(locale, { style: "currency", currency: currency ?? undefined })
    .replace(/\d./g, "")
    .trim()
}

export const getCurrencySeparator = (locale?: string): string => {
  return (1.1).toLocaleString(locale).replace(/\d/g, "")
}

export const DEFAULT_MAXIMUM_AMOUNT = 99999999
